import { render, staticRenderFns } from "./category-contest.vue?vue&type=template&id=4a948eb8"
import script from "./category-contest.vue?vue&type=script&lang=js"
export * from "./category-contest.vue?vue&type=script&lang=js"
import style0 from "./category-contest.vue?vue&type=style&index=0&id=4a948eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports